import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-213ccf72");

var _hoisted_1 = {
  class: "list-wrapper"
};
var _hoisted_2 = {
  class: "commodity-list"
};
var _hoisted_3 = {
  key: 0
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_List_join_item = _resolveComponent("List-join-item");

  var _component_van_loading = _resolveComponent("van-loading");

  var _component_van_empty = _resolveComponent("van-empty");

  var _component_van_list = _resolveComponent("van-list");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_list, {
    modelValue: $data.loading,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.loading = $event;
    }),
    finished: $data.finished,
    onLoad: $options.onLoad
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [$data.list.length ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, function (item, id) {
        return _openBlock(), _createElementBlock("li", {
          key: id
        }, [_createVNode(_component_List_join_item, {
          "onUpdate:activeIndex": $options.updateActiveIndex,
          item: item
        }, null, 8, ["onUpdate:activeIndex", "item"])]);
      }), 128))])) : $data.loading ? (_openBlock(), _createBlock(_component_van_loading, {
        key: 1,
        type: "spinner",
        class: "loading"
      })) : (_openBlock(), _createBlock(_component_van_empty, {
        key: 2,
        class: "custom-image",
        image: "https://cdn-fs.touchev.com/d/file/special/2023/spring-activity-2/content-null.png!w480",
        description: "暂无参与记录～"
      }))])];
    }),
    _: 1
  }, 8, ["modelValue", "finished", "onLoad"])]);
}